module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-network-tab4.061a3379.png";